module.exports = __webpack_public_path__ + "static/img/1.b8c43dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market101/1.png
// module id = +Cpg
// module chunks = 1